import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.billing'),
    id: 'accounting',
    sidebar: [
        {
            id: 'billable',
            label: i18n.t('configuration.sections.billing'),
            icon: 'fal fa-calculator',
            routeName: 'BillableUnits',
            active: true,
            hasChildren: true,
            children: [
                {
                    id: 'units',
                    label: i18n.tc('configuration.sections.unit', 2),
                    routeName: 'BillableUnits',
                    hasChildren: false
                },
                {
                    id: 'groupOfConcepts',
                    label: i18n.tc('configuration.sections.groupOfConcepts', 2),
                    routeName: 'BillableGroupsOfConcepts',
                    hasChildren: false
                },
                {
                    id: 'concepts',
                    label: i18n.tc('configuration.sections.concept', 2),
                    routeName: 'BillableConcepts',
                    hasChildren: false
                },
                {
                    id: 'customerGroups',
                    label: i18n.tc('configuration.sections.groupOfClient', 2),
                    routeName: 'BillableCustomerGroups',
                    hasChildren: false
                },
                {
                    id: 'customerTypes',
                    label: i18n.tc('configuration.sections.typeOfClient', 2),
                    routeName: 'BillableCustomerTypes',
                    hasChildren: false
                },
                {
                    id: 'paymentMethod',
                    label: i18n.tc('configuration.sections.typeOfPayment', 2),
                    routeName: 'BillablePaymentTypes',
                    hasChildren: false
                }
            ]
        }
        // TODO: Pending implementation
        // {
        //     id: 'nonBillable',
        //     label: i18n.t('configuration.sections.serviceActivity'),
        //     icon: 'fal fa-user-clock',
        //     routeName: 'Units',
        //     active: true,
        //     hasChildren: true,
        //     children: [
        //         {
        //             id: 'units',
        //             label: i18n.tc('configuration.sections.unit', 2),
        //             routeName: 'NonBillableUnits',
        //             hasChildren: false
        //         },
        //         {
        //             id: 'breakdowns',
        //             label: i18n.tc('configuration.sections.breakdown', 2),
        //             routeName: 'NonBillableBreakdowns',
        //             hasChildren: false
        //         },
        //         {
        //             id: 'groupOfConcepts',
        //             label: i18n.tc('configuration.sections.groupOfConcepts', 2),
        //             routeName: 'NonBillableGroupsOfConcepts',
        //             hasChildren: false
        //         },
        //         {
        //             id: 'concepts',
        //             label: i18n.tc('configuration.sections.concept', 2),
        //             routeName: 'NonBillableConcepts',
        //             hasChildren: false
        //         }
        //     ]
        // }
    ]
}
